<script lang="ts">
	import SignUpLayout from '$lib/components/layouts/SignUpLayout.svelte'
	import LogoTenantHandler from '$lib/components/logo/LogoTenantHandler.svelte'
	import TrackdeskBrand from '$lib/components/trackdeskBrand/TrackdeskBrand.svelte'
	import UserMenu from '$lib/components/userMenu/UserMenu.svelte'
	import AffiliateRegistrationIllustration from '$lib/domain/affiliates/registration/AffiliateRegistrationIllustration.svelte'
	import { useAffiliateRegistrationCustomizationQuery } from '$lib/domain/affiliates/registration/affiliateRegistrationCustomizationQuery'
	import { checkFeature } from '$lib/domain/upgrade/checkFeature.js'
	import { _ } from '@repo/i18n'
	import { Headline, user } from '@repo/ui'
	import { EnumsV1AffiliateRegistrationPageStyle, EnumsV1FeatureId } from '@sdk/Api'

	interface Props {
		children?: import('svelte').Snippet
	}

	let { children }: Props = $props()

	const query = useAffiliateRegistrationCustomizationQuery()
</script>

<svelte:head>
	<title>{$_('title.signUp')}</title>
</svelte:head>

<SignUpLayout
	additionalClasses="bg-primary-500/5"
	affiliate
	minimalist={$query.data?.pageStyle ===
		EnumsV1AffiliateRegistrationPageStyle.AFFILIATE_REGISTRATION_PAGE_STYLE_MINIMALIST}
>
	{#snippet logo()}
		<LogoTenantHandler center />
	{/snippet}

	{#snippet login()}
		<div>
			{#if $user}
				<UserMenu />
			{:else}
				<div class="text-sm text-gray-600 dark:text-gray-200">
					{$_('signUp.haveAccount')}

					<a class="text-primary-500 font-bold underline hover:no-underline" href="/">
						{$_('signUp.logIn')}
					</a>
				</div>
			{/if}
		</div>
	{/snippet}

	{#snippet illustration()}
		<AffiliateRegistrationIllustration customization={$query.data} />
	{/snippet}

	<Headline level="special" tagName="h1">
		{$_('signUp.headline')}
	</Headline>

	{@render children?.()}

	{#snippet bottom()}
		{#if !$checkFeature(EnumsV1FeatureId.FEATURE_ID_FULL_WHITE_LABEL)}
			<div class="mt-8"></div>
			<TrackdeskBrand />
		{/if}
	{/snippet}
</SignUpLayout>
